import { CreateFocusCss } from '../../../styles'
import { styles } from '../../../utilities'
import type { Tokens } from '../../../theming/types'
import type { LinkProps } from '../Link'

export default (config: {
  props: Pick<LinkProps, 'size' | 'kind' | 'discrete'> & {
    isTextWithTextEllipsis?: boolean
  }
  tokens: Tokens
}) => {
  const { props, tokens } = config

  const isSubtle = props.kind === 'subtle'
  return {
    default: {
      link: {
        background: 'none',
        border: 'none',
        borderRadius: 0,
        color: isSubtle ? tokens.fontColorLinkSubtle : tokens.fontColorLink,
        cursor: 'pointer',
        display: props.isTextWithTextEllipsis ? 'inline-flex' : undefined,
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        letterSpacing: 'normal',
        lineHeight: 'inherit',
        padding: 0,
        margin: 0,
        textAlign: 'inherit',
        textDecoration: props.discrete ? 'inherit' : 'none',

        ...CreateFocusCss(tokens.focusOuter),

        '&:hover': {
          color: isSubtle
            ? tokens.fontColorLinkSubtleHover
            : tokens.fontColorLinkHover,
          textDecoration: 'underline',
        },

        '&:active': {
          color: isSubtle
            ? tokens.fontColorLinkSubtleActive
            : tokens.fontColorLinkActive,
          textDecoration: 'none',
        },

        '&:disabled': {
          color: tokens.fontColorDisabled,
          cursor: 'default',
          textDecoration: 'none',

          '&:hover': {
            color: tokens.fontColorDisabled,
            textDecoration: 'none',
          },
        },

        '&:visited': {
          color: isSubtle
            ? tokens.fontColorLinkSubtleVisited
            : tokens.fontColorLinkVisited,
        },

        '&:focus': {
          color: isSubtle
            ? tokens.fontColorLinkSubtleHover
            : tokens.fontColorLinkHover,
        },
      },
    },

    hidden: styles.visuallyHidden,
  } as const
}
